<template>
    <div class="loading">
        <p>
            <slot>Loading</slot>
        </p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.loading {
    background-color: rgba(17, 17, 17, 0.9);

    p {
        background-position: -16px center;
        background-size: 76px;

        @media screen and (max-width: 420px) and (min-width: 320px) {
            background-position: -13px center;
        }
    }
}
</style>
